// Get the nearest region
export const getNearestRegion = (element) => {
  const region = element.closest('[data-region]');
  const regionName = region ? region.dataset.region : 'Page Content';
  return {
    name: regionName,
    element: region,
  };
};

// Get link destination with hash handling
export const getDestinationUrl = (link) => {
  const { pathname, hash = '' } = link;

  // If the link is to the current page, return the hash
  if (document.location.pathname === pathname) {
    return hash;
  }
  return `${pathname}${hash}`;
};

// Link clicks are either CTAs, Phone Numbers, Jump Links, or Links
export const getDestinationType = (link) => {
  const category = link.dataset.category;

  // Phone numbers
  if (link.href.startsWith('tel:')) {
    return 'Call';
  }

  const isJumpLink =
    (link.hash && link.pathname === document.location.pathname) ||
    link.href.endsWith('#');

  // Remap "Action" (CTAs)
  if (category === 'Action') {
    return isJumpLink ? 'Self' : 'Page';
  }

  // Jump links
  if (isJumpLink) {
    return 'Jump Link';
  }

  // Default to "Link" if no category is set
  return category || 'Link';
};

// Get the position of an element within the region by 1 based index
export const getElementPosition = (element, region, selector) => {
  const els = [...region.querySelectorAll(selector)];
  return `${els.indexOf(element) + 1} of ${els.length}`;
};

// Get the number of non-hidden inputs in a form
export const getNonHiddenInputCount = (form) => {
  return form.querySelectorAll('input:not([type="hidden"])').length;
};
